import { EFinancingProgram } from '@if/core/types'
import { ButtonProps } from '@mui/material'
import AsyncActionButton from '@src/components/AsyncActionButton'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

interface Props extends ButtonProps {
  id: string
  financingProgramId: EFinancingProgram
  disabled: boolean
}

const FundingSummaryButton = ({ id, financingProgramId, disabled }: Props) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <AsyncActionButton
      disabled={disabled}
      fullWidth
      variant="contained"
      onClick={() => navigate(`/credits/${financingProgramId}/${id}/funding-summary`)}
    >
      {t('viewCreditApplication.printFundingSummary')}
    </AsyncActionButton>
  )
}

export default FundingSummaryButton
